import { createContext, useContext, useEffect } from "react";
import { Outlet } from "react-router";
import { useTabState } from "reakit/Tab";

import ProfileHeader from "../Profile/ProfileHeader";
import { useProfileTabsData } from "../Profile/useProfileTabsData";
import PushableContainer from "../Utils/PushableContainer";

const ProfileLayoutContext = createContext();

export const useProfileLayout = () => useContext(ProfileLayoutContext);

// This component renders the general profile section layout, which allows managing the
// tabs state and data, and making the tabs and panels accessible for screen readers and
// keyboard navigation.
const ProfileLayoutRoute = () => {
  const tabsData = useProfileTabsData();
  const currentTab = tabsData.find(({ isActive }) => isActive);
  const { tabId, tabPanelId } = currentTab || {};

  const tabState = useTabState({ manual: true, currentId: tabId });
  const { setCurrentId } = tabState;

  useEffect(() => {
    setCurrentId(tabId);
  }, [setCurrentId, tabId]);

  if (!currentTab) return null;

  return (
    <ProfileLayoutContext.Provider value={{ tabState, tabsData }}>
      <PushableContainer className="profile container">
        <ProfileHeader />

        <div id={tabPanelId} role="tabpanel" tabIndex="0" aria-labelledby={tabId}>
          <Outlet />
        </div>
      </PushableContainer>
    </ProfileLayoutContext.Provider>
  );
};

export default ProfileLayoutRoute;
